export default "__VITE_ASSET__DfQ2H0U7__"